'use strict';

bbw.model.PhotoAlbum = ngtk.model.List.extend({

    statics: {
        DEFAULT_SIZE_NAME: 'medium',
        DEFAULT_FULL_SIZE_NAME: 'default',
        METHOD_GET_FOREIGN: 'photos/{album_type}/{user_id}/{size_name}/{full_size_name}/{extra_size_name}',
        METHOD_GET_OWN: 'user/photos/{album_type}/{size_name}/{full_size_name}/{extra_size_name}',
        ALBUM_TYPE_PUBLIC: 'public',
        ALBUM_TYPE_PRIVATE: 'private'
    },

    _itemModel: bbw.model.Photo,

    _albumAttrs: undefined,

    _count: undefined,
    _album: undefined,
    _isLoaded: false,
    _loadedAt: undefined,
    _loadingPromise: undefined,

    isLoaded: function() {
        return this._isLoaded;
    },

    _initialize: function() {
        this.parent._initialize.call(this);
        this._album = {};
    },

    prepare: function(attrs) {
        if (!angular.isObject(attrs)) {
            throw new Error("Invalid argument");
        }
        this._albumAttrs = attrs;
        return this;
    },

    ensureIsLoaded: function(reloadExpireSec) {
        if (this._loadingPromise) {
            return this._loadingPromise;
        }
        if (this._isLoaded && !this._needsReload(reloadExpireSec)) {
            return this.$q.when(true);
        }
        return this._load();
    },

    _needsReload: function(reloadExpireSec) {
        if (angular.isUndefined(reloadExpireSec)) {
            return false;
        }
        if (angular.isUndefined(this._loadedAt)) {
            return true;
        }
        return (new Date() - this._loadedAt) / 1000 > reloadExpireSec;
    },

    load: function(attrs) {
        if (angular.isDefined(attrs)) {
            this.prepare(attrs);
        }
        return this._load();
    },

    getUploadLimit: function() {
        return Math.max(0, this._album.capacity - this._count);
    },

    getCount: function() {
        return this._count;
    },

    getAlbum: function() {
        return this._album;
    },

    reload: function() {
        return this._load();
    },

    makeMain: function(photo) {
        return photo.setMain().then(function() {
            this.forEach(function(item) {
                if (item.getId() != photo.getId()) {
                    item.merge({is_main: false});
                }
            });
        }.bind(this));
    },

    setPhotoOrder: function(id, position) {
        return this._loadFromApi('post', 'user/photos/set-order', {
            album_type: this._album.type,
            photo_id: id,
            position: position
        });
    },

    findMainPhoto: function() {
        for (var photoId in this._items) {
            if (this._items.hasOwnProperty(photoId) && this._items[photoId].get && this._items[photoId].get('is_main')) {
                return this._items[photoId];
            }
        }
        return undefined;
    },

    deletePhoto: function(id, keepInCollection, userId) {
        return this._loadFromApi('post', userId ? 'admin/photos/delete' : 'user/photos/delete', {
            album_type: this._album.type,
            photo_id: id,
            user_id: userId
        }).then(function(response) {
            keepInCollection || this.unset(id);
            if (this._count > 0) {
                --this._count;
            }
            if (response.new_main_photo_id) {
                var photo = this.get(response.new_main_photo_id);
                if (photo) {
                    photo.merge({is_main: true});
                    return this.$q.when(photo);
                }
            }
            return this.$q.when(undefined);
        }.bind(this));
    },

    _load: function() {
        this._isLoaded = false;
        if (angular.isUndefined(this._albumAttrs)) {
            throw new Error('Album attributes not defined: load(attrs) not called?');
        }
        var method, args = {}, attrs = this._albumAttrs;
        if (attrs.user_id) {
            method = bbw.model.PhotoAlbum.METHOD_GET_FOREIGN;
            args.user_id = attrs.user_id;
        } else {
            method = bbw.model.PhotoAlbum.METHOD_GET_OWN;
        }
        angular.extend(args, {
            album_type: attrs.album_type || 'public',
            size_name: attrs.size || bbw.model.PhotoAlbum.DEFAULT_SIZE_NAME,
            full_size_name: attrs.full_size || bbw.model.PhotoAlbum.DEFAULT_FULL_SIZE_NAME,
            extra_size_name: attrs.extra_size || ''
        });
        if (attrs.moderated_only) {
            args.moderated_only = 1;
        }
        this._loadingPromise = this._loadFromApi('get', method, args).then(function(response) {
            this._setFromApiResult(response.photos.items);
            this._count = response.photos.count;
            this._isLoaded = true;
            this._loadedAt = new Date();
            ngtk.tools.object.replace(this._album, response.photos.album || {});
        }.bind(this));
        return this._loadingPromise.finally(function() {
            this._loadingPromise = undefined;
        }.bind(this));
    },

    addPhoto: function(photo) {
        this.set(photo.getId(), photo);
        if (angular.isUndefined(this._count)) {
            this._count = 0;
        }
        ++this._count;
    },

    _wireScope: function(scope, scopeInnerPtr, scopeInnerElement) {
        this.parent._wireScope.apply(this, arguments);
        scopeInnerPtr[scopeInnerElement]['album'] = this._album;
    }

});